"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newDrillToSameDashboardHandler = void 0;
// (C) 2021 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var commands_1 = require("../commands");
var events_1 = require("../events");
/**
 * Event handler with the default implementation for drill to the same dashboard.
 *
 * When {@link DashboardDrillToDashboardResolved} event is fired and contains dashboard ref that matches the provided dashboard ref,
 * or dashboard ref in the event is missing, it sets relevant drill intersection filters to the current dashboard.
 *
 * Note that only filters that are already stored in the dashboard filter context will be applied
 * (attribute filters that are not visible in the filter bar will not be applied).
 *
 * @alpha
 * @param dashboardRef - reference to the current dashboard
 * @returns event handler
 */
exports.newDrillToSameDashboardHandler = function (dashboardRef) { return ({
    eval: events_1.newDashboardEventPredicate("GDC.DASH/EVT.DRILL.DRILL_TO_DASHBOARD.RESOLVED", function (e) {
        return !e.payload.drillDefinition.target ||
            sdk_model_1.areObjRefsEqual(e.payload.drillDefinition.target, dashboardRef);
    }),
    handler: function (event, dispatch) {
        dispatch(commands_1.changeFilterContextSelection(event.payload.filters));
    },
}); };
//# sourceMappingURL=drillToSameDashboardHandlerFactory.js.map